import{jsx as r}from"react/jsx-runtime";function t({type:e}){return r("div",{children:e==="not-found"?"The job offer has been closed":"There was an error while connecting to job service"})}export{t as Alert};
